import React from "react";
import KategoriDrink from "../../KategoriDrink";
import List from "../../list_categori";

const drinks = [
  "Es Teh Manis",
  "Kopi Susu",
  "Ice Blended Coklat",
  "Jus Alpukat",
  "Thai Tea",
  "Lemon Tea",
  "Es Teh Manis",
  "Kopi Susu",
  "Ice Blended Coklat",
  "Jus Alpukat",
  "Thai Tea",
  "Lemon Tea",
];

const foods = [
  "Nasi Goreng",
  "Mie Ayam",
  "Sate Ayam",
  "Bakso",
  "Ayam Geprek",
  "Soto Ayam",
  "Nasi Goreng",
  "Mie Ayam",
  "Sate Ayam",
  "Bakso",
  "Ayam Geprek",
  "Soto Ayam",
];

export default function MenuPage() {
  return (
    <>
     <KategoriDrink/>
     <List/>
      <div className="min-h-screen bg-white text-black py-10 px-4 flex items-center justify-center text-modifikasi">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl w-full">
          
          {/* KIRI - DRINK */}
          <div className="bg-white rounded-2xl shadow-md p-6 shadow-pink-700">
            {/* Gambar Potret */}
            <img
              src="http://4.bp.blogspot.com/-zvsDpziZgNg/VeYMlPQCF4I/AAAAAAAABfY/CP9DUpOQBPw/s1600/Buku_Daftar_Menu_Nasi_Timbel_3.png" // Ganti dengan gambar asli
              alt="Drink Banner"
              className="w-full h-98 object-cover rounded-xl mb-10"
            />
            {/* Daftar Minuman */}
            <h2 className="text-3xl font-bold text-left mb-10 uppercase">Daftar Menu Drink</h2>
            <ul className="space-y-2">
              {drinks.map((drink, index) => (
                <li key={index} className="font-semibold pb-1">
                  {drink}
                </li>
              ))}
            </ul>
          </div>

          {/* KANAN - FOOD */}
          <div className="bg-white rounded-2xl shadow-md shadow-pink-700 p-6">
            {/* Daftar Makanan */}
            <h2 className="text-3xl font-bold text-left mb-10 uppercase">Daftar Menu Food</h2>
            <ul className="space-y-2">
              {foods.map((food, index) => (
                <li key={index} className="font-semibold pb-1">
                  {food}
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </>
  );
}
